export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_10032_NEW_TRANSCRIPT': 'New Transcript',
    '_10033_A_NEW_TRANSCRIPT_IS_READY_FOR___USERNAME__': 'A new transcript is ready for {{userName}}',
    '_789_VIEW': 'View',
    '_10034_DISMISS': 'Dismiss'
};
